import React from "react";
import BackgroundDiv from "../misc/elements/BackgroundDiv";

const Header = ({ shortDescription }) => {
  return (
    <div
      className="divRow"
      style={{
        width: "100%",
        position: "relative",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          position: "absolute",
          width: "80%",
          height: "30px",
        }}
      >
        <BackgroundDiv backgroundColor={"#efefef"} opacity={0.5} />
      </div>
      <div
        className="textBold"
        style={{ fontSize: "25px", color: "#1f1f1f", zIndex: 1 }}
      >
        {shortDescription}
      </div>
    </div>
  );
};

export default Header;
